/**
 * Shared metrics for the three-column educator-resources page.
 *
 * The pack rail, the folder rail and the content pane each carry their own
 * header, and each header is followed by a rule. Those rules only read as one
 * line across the page if all three bands are the same height, which means the
 * number has to be shared rather than re-derived per column — a column that
 * sizes to its own content drifts the moment its text changes.
 *
 * It lives in its own module because the rails are imported by the page, so a
 * constant exported from the page would close an import cycle.
 */

/**
 * Height of every column header, in px.
 *
 * Sized for the tallest of the three: an h6 title over a caption, which is
 * roughly 52px of text, plus enough room to breathe. The rails hold a
 * subtitle2 over a caption and centre inside the same band.
 */
export const HEADER_HEIGHT = 72
